export function buildBifurcationParams(service, selectedPackage, promoCode) {
  return {
    removeAllCharges: true,
    walletOptedIn: 1,
    refundOptIn: 0,
    serviceType: 1,
    serviceId: Number(service.serviceId),
    vendorId: service.vendorId || '',
    itemType: service.itemType || (service.serviceName || '').toUpperCase(),
    itemId: String(selectedPackage.id),
    checkout: 0,
    isConsultCorporateWalletOptedIn: 0,
    promoCode: promoCode || null,
  };
}
